import { useState } from 'react';
import {CSSTransition} from "react-transition-group";

export function Footer (props) {
    require("./footer.css");

    const BackgroundColor = (props.theme) ? props.backgroundColor : props.backgroundColorDark
    const PrimaryColor = (props.theme) ? props.primaryColor : props.primaryColorDark
    const BorderColor = (props.theme) ? props.borderColor : props.borderColorDark
    const PrimaryFontColor = (props.theme) ? props.primaryFontColor : props.primaryFontColorDark
    const SecondaryFontColor = (props.theme) ? props.secondaryFontColor : props.secondaryFontColorDark

    if (
        [
            props.importantLinks,
            props.importantLinksColumnHead,
            props.logo,
            props.SvgFollowUs,
            props.description,
            props.copyright,
            PrimaryColor,
            BackgroundColor,
            BorderColor,
            PrimaryFontColor,
            SecondaryFontColor,
        ].includes(undefined)
    ) {
        return(
            <div style={{height:"500px",border:"10px solid red",padding:"20px"}}>
                <h2>ERROR: Footer has undefined parameters</h2> <br/>
                <h2>Looks like one or many of the parameters we need is <span style={{color:"red"}}>undefined</span>! </h2>  <br/>
                <h2>The required parameters are :</h2> <br/>
                <p>
                    <b>importantLinks</b> = Link[] | import  {`{Link}`} from "react-router-dom"; <br/>
                    <b>importantLinksColumnHead</b> = string[] | ["Navigate", "Legal", "Important links",] <br/>
                    <b>logo</b> = {`<img src="path/to/logo"/>`} <br/>
                    <b>SvgFollowUs</b> = {`{"https://facebook.com/mypage": *importedFacebookSvg*, "https://twitter.com/mypage": *importedTwitterSvg*}`} | import Facebook from "../assets/SVG/facebook.svg"; <br/>
                    <b>description</b> = "string" <br/>
                    <b>primaryColor</b> = "red" <br/>
                    <b>backgroundColor</b> = "white" <br/>
                    <b>borderColor</b> = "lightgray" <br/>
                    <b>primaryFontColor</b> = "black" | <b>optional</b> <br/>
                    <b>secondaryFontColor</b> = "white" | <b>optional</b> <br/>
                </p>
            </div>
        );
    }

    var followUsImgs = [];
    Object.keys(props.SvgFollowUs).forEach(function(key) {
        followUsImgs.push(<a key={key} href={key}><img width="50" src={props.SvgFollowUs[key]} alt={key}/></a>)
    });

    return (
        <footer id="MyersFooter_Standard" style={{backgroundColor:BackgroundColor, borderColor: BorderColor, color:PrimaryFontColor}}>
            <div id="MyersFooter_Standard_top">
                
                <div id="MyersFooter_Standard_main">
                    {props.logo}
                    <p id="MyersFooter_Standard_desc">{props.description}</p>
                </div>
                <div id="MyersFooter_Standard_important_links">
                    <div id="MyersFooter_Standard_important_links_1">
                        <p>{props.importantLinksColumnHead[0]}</p>
                        {props.importantLinks[0]}
                    </div>
                    <div id="MyersFooter_Standard_important_links_2">
                    <p>{props.importantLinksColumnHead[1]}</p>
                        {props.importantLinks[1]}
                    </div>
                    <div id="MyersFooter_Standard_important_links_3">
                        <p>{props.importantLinksColumnHead[2]}</p>
                        {props.importantLinks[2]}
                    </div>
                </div>
            </div>
            <div style={{height:"1px",backgroundColor:BorderColor, width:"80%", margin:"auto"}}></div>
            <div id="MyersFooter_Standard_follow_us">
                {followUsImgs}
            </div>
            <div style={{backgroundColor:PrimaryColor}} id="MyersFooter_Standard_cc">
                <p style={{color:SecondaryFontColor,fontWeight:"bold"}}>{props.copyright}</p>
            </div>
        </footer>
    );
}


export function Header (props) {
    require("./header.css");

    const BackgroundColor = (props.theme) ? props.backgroundColor : props.backgroundColorDark
    const BorderColor = (props.theme) ? props.borderColor : props.borderColorDark
    const PrimaryColor = props.primaryColor
    const BoxShadow = (props.theme) ? props.boxShadowColor : props.boxShadowColorDark
    const MobileMenuOption = (props.mobileMenuOption == undefined) ? true : false;

    const MobileMenu = <div style={{backgroundColor:BackgroundColor}} id="MyersHeader_Standard_Mobile_menu">
        <div style={{marginTop: 120}}></div>
    </div>
    const [inPropMenu, displayMobileMenu] = useState(false);

    const MobileTrigger = (MobileMenuOption) ? <button style={{backgroundColor: PrimaryColor, border: "3px solid " + BorderColor}} id="MyersHeader_Standard_Mobile_menu_button" onClick={() => displayMobileMenu((inPropMenu)?false:true)}> 
        </button> : "";

    return (
        <>
        <header id="MyersHeader_Standard" style={{boxShadow:"0 0 5px 0 " + BoxShadow ,backgroundColor:BackgroundColor, borderBottom:(inPropMenu)? "3px solid " + BorderColor : "none"}}>
            {props.logo}
            <div id="MyersHeader_Standard_Desktop_links">
                {props.links}
            </div>
            {MobileTrigger}
        </header>
        <CSSTransition
            in={inPropMenu}
            timeout={300}
            classNames="mobile_menu"
        >
            {MobileMenu}
        </CSSTransition>
        </>
    );
}